import { render } from "./ModalPerfil.vue?vue&type=template&id=6594b65c&ts=true"
import script from "./ModalPerfil.vue?vue&type=script&lang=ts"
export * from "./ModalPerfil.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\wamp64\\www\\sisdeu\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__